/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StockStorageFeeListResVo } from './StockStorageFeeListResVo';
import {
    StockStorageFeeListResVoFromJSON,
    StockStorageFeeListResVoFromJSONTyped,
    StockStorageFeeListResVoToJSON,
    StockStorageFeeListResVoToJSONTyped,
} from './StockStorageFeeListResVo';

/**
 * 
 * @export
 * @interface ResponseListStockStorageFeeListResVo
 */
export interface ResponseListStockStorageFeeListResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListStockStorageFeeListResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListStockStorageFeeListResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<StockStorageFeeListResVo>}
     * @memberof ResponseListStockStorageFeeListResVo
     */
    data?: Array<StockStorageFeeListResVo>;
}

/**
 * Check if a given object implements the ResponseListStockStorageFeeListResVo interface.
 */
export function instanceOfResponseListStockStorageFeeListResVo(value: object): value is ResponseListStockStorageFeeListResVo {
    return true;
}

export function ResponseListStockStorageFeeListResVoFromJSON(json: any): ResponseListStockStorageFeeListResVo {
    return ResponseListStockStorageFeeListResVoFromJSONTyped(json, false);
}

export function ResponseListStockStorageFeeListResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListStockStorageFeeListResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(StockStorageFeeListResVoFromJSON)),
    };
}

export function ResponseListStockStorageFeeListResVoToJSON(json: any): ResponseListStockStorageFeeListResVo {
    return ResponseListStockStorageFeeListResVoToJSONTyped(json, false);
}

export function ResponseListStockStorageFeeListResVoToJSONTyped(value?: ResponseListStockStorageFeeListResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(StockStorageFeeListResVoToJSON)),
    };
}

